import { Layout } from 'antd'
import AvatarIcon from './components/AvatarIcon'
import Logo from '../Menu/components/Logo'
import './index.less'

const LayoutHeader = () => {
  const { Header } = Layout
  const isEnvTest = window.location.host === 'crush-admin-staging.makefriends-inc.com'

  return (
    <Header>
      <div className='header-lf'>
        <Logo></Logo>
      </div>

      {isEnvTest && (
        <div className='header-md' style={{ color: 'red' }}>
          <h2>当前为测试环境</h2>
        </div>
      )}

      <div className='header-ri'>
        <AvatarIcon />
      </div>
    </Header>
  )
}

export default LayoutHeader
